import React from 'react';
import { motion } from 'framer-motion';

const OffersSlider: React.FC = () => {
    return (
        <motion.div className="offers-slider" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
            <h2>Special Offers</h2>
            <div className="slider">
                <div className="offer">50% Off - Hotel 1</div>
                <div className="offer">25% Off - Hotel 2</div>
                <div className="offer">30% Off - Hotel 3</div>
            </div>
        </motion.div>
    );
};

export default OffersSlider;

